import { PrepareScreenForPicnicApiCall as BLPrepareScreenForPicnicApiCall, StartPicnicMatchApiCall as BLStartPicnicMatchApiCall, StopPicnicMatchApiCall as BLStopPicnicMatchApiCall, SendPicnicScoreProgressApiCall as BLSendPicnicScoreProgressApiCall } from './../DL/Picnic';
import SignalRService from '../WS/SignalRService';

const PreparePicnicDayScreen = async () => {
    try {
        const response = await BLPrepareScreenForPicnicApiCall();
        return response;
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al preparar pantalla." };
    }
};

const StartPicnicDayMatch = async (matchConfigurationObject) => {
    try {
        if (!matchConfigurationObject) {
            return { success: false, message: "La configuración del juego está vacía." };
        }
        if (matchConfigurationObject.roundDurationSeconds < 10) {
            return { success: false, message: "La partida debe durar al menos 10 segundos." };
        }

        const durationForBackend = parseInt(matchConfigurationObject.roundDurationSeconds);
        const settingsAsJsonString = JSON.stringify(matchConfigurationObject);

        const response = await BLStartPicnicMatchApiCall(durationForBackend, settingsAsJsonString);
        return response;

    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al iniciar partida." };
    }
};

const StopPicnicDayMatch = async (currentMatchIdentifier) => {
    try {
        if (!currentMatchIdentifier) {
            return { success: false, message: "No hay una partida activa para detener." };
        }

        const response = await BLStopPicnicMatchApiCall(currentMatchIdentifier);
        return response;
    } catch (error) {
        return { success: false, message: "Excepción en la lógica de negocio al detener partida." };
    }
};

let picnicPlayerMessageHandler = null;
let picnicPlayerReconnectedHandler = null;

const ConnectPicnicWebSocket = async (playerId, onStatus = () => {}, onToast = () => {}) => {
    onStatus('connecting');

    picnicPlayerReconnectedHandler = () => {
        onStatus('connected');
    };

    SignalRService.on('reconnected', picnicPlayerReconnectedHandler);

    SignalRService.connect({ tipo: `picnic:${playerId}` })
        .then(() => {
            onStatus('connected');
            onToast('¡Conectado!');
        })
        .catch((err) => {
            console.error("[PicnicWS] Error al conectar a SignalR:", err);
            onStatus('error');
        });
};

const SetPicnicSocketMessageHandler = (handler) => {
    if (picnicPlayerMessageHandler) {
        SignalRService.off('message', picnicPlayerMessageHandler);
    }

    picnicPlayerMessageHandler = (envelope) => {
        handler(envelope);
    };

    SignalRService.on('message', picnicPlayerMessageHandler);
};

const ClearPicnicSocketMessageHandler = () => {
    if (picnicPlayerMessageHandler) {
        SignalRService.off('message', picnicPlayerMessageHandler);
        picnicPlayerMessageHandler = null;
    }
};

const DisconnectPicnicWebSocket = () => {
    if (picnicPlayerMessageHandler) {
        SignalRService.off('message', picnicPlayerMessageHandler);
        picnicPlayerMessageHandler = null;
    }
    if (picnicPlayerReconnectedHandler) {
        SignalRService.off('reconnected', picnicPlayerReconnectedHandler);
        picnicPlayerReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

const SendPicnicScoreProgress = async ({ matchId, playerId, currentScore }) => {
    if (!matchId || !playerId) return false;
    return await BLSendPicnicScoreProgressApiCall(matchId, playerId, currentScore);
};

export { PreparePicnicDayScreen, StartPicnicDayMatch, StopPicnicDayMatch, ConnectPicnicWebSocket, SetPicnicSocketMessageHandler, ClearPicnicSocketMessageHandler, DisconnectPicnicWebSocket, SendPicnicScoreProgress };